import { render, staticRenderFns } from "./CampaignSettingsIntegrationsListItem.vue?vue&type=template&id=0fcda7b6&scoped=true&"
import script from "./CampaignSettingsIntegrationsListItem.vue?vue&type=script&lang=js&"
export * from "./CampaignSettingsIntegrationsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcda7b6",
  null
  
)

export default component.exports